<div class="p-10">
  <ion-row>
    <ion-col size="4" size-sm="8" size-xs="8">
      <p class="formLabelBoldfs18">Color Palatte</p>
    </ion-col>
    <ion-col size="8" size-sm="4" size-xs="4" class="text-right">
      <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <div class="formLabelBoldfs16">Menus</div>
      <div class="mt-10 cardBox">
        <input type="color" class="cp rounded-color-picker" [value]="moduleNameColor" (input)="onColorChangeModule($event)"/>
      </div>
    </ion-col>
    <ion-col size="12">
      <div class="formLabelBoldfs16">Sub-Headings / Tabs</div>
      <div class="mt-10 cardBox">
        <input type="color" class="cp rounded-color-picker" [value]="subModuleButtonColor" (input)="onColorChangeSubModule($event)"/>
      </div>
    </ion-col>
    <ion-col size="12">
      <div class="formLabelBoldfs16">Buttons</div>
      <div class="mt-10 cardBox">
        <input type="color" class="cp rounded-color-picker" [value]="buttonColorName" (input)="onColorChangeButton($event)"/>
      </div>
    </ion-col>
    <ion-col size="12">
      <div class="formLabelBoldfs16">Dashboards graphs/ charts</div>
      <ion-row class="cardBox mt-10">
        <ion-col size-sm="8" size-md="10" size-lg="10" size-xs="8" class="p-0">
          <label *ngFor="let item of dashboardList;let i=index" class="d-inline-table"
          (mouseenter)="onMouseEnter(i)" (mouseleave)="onMouseLeave(i)">
            <input  #colorPicker (click)="$event.stopPropagation()" type="color" class="cp rounded-color-picker" [value]="item" (input)="onColorChange($event,i)" />
          </label>
        </ion-col>
        <ion-col size-sm="4" size-md="2" size-lg="2" size-xs="4" class="p-0 d-flex align-center">
          <label class="plusIcon cp" (click)="addMoreDashboardColor()">+</label>
          <label class="plusIcon cp" (click)="removeDashboardColor()">-</label>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
  <ion-row class="p-0 mt-20">
    <ion-col class="d-flex float-right">
      <button class="font_medium import_btn mr-30 mr-10ForMobileView" (click)="onClickPreview()">Preview</button>
      <button class="font_medium back_btn mr-30 mr-10ForMobileView" (click)="btn1Action()">Cancel</button>
      <button class="font_medium add_btn" [style.background-color]="buttonColorName" (click)="btn2Action()" >Apply</button>
    </ion-col>
  </ion-row>
</div>